import { typography } from "@joor/design-system";
import styled from "styled-components/macro";

const StyledWrapper = styled.div``;
const StyledTitle = styled.h1`
  ${typography.alpha.primaryActive.headline1}
  margin-top: 30px;
  text-transform: none;
  letter-spacing: 0;
  text-align: center;
`;
const StyledInfo = styled.p`
  ${typography.alpha.primaryActive.subtitle3}
  color: var(--color-primary-200);
  font-style: italic;
  line-height: 18px;
  margin-bottom: 30px;
  text-align: center;
`;
export const ErrorPage = (
  { error }: { error: Error },
  customMessage?: string
) => (
  <StyledWrapper>
    <StyledTitle>We're Sorry—</StyledTitle>
    <StyledInfo>
      {customMessage
        ? customMessage
        : "Something unexpected has happened. This issue has been logged."}
    </StyledInfo>
    <StyledInfo>{error.message}</StyledInfo>
  </StyledWrapper>
);
